module.exports = __webpack_public_path__ + "static/2026yapayzekaarama-23d524f6d2430b7ef8c20b2f09daf103.jpg";